import React from 'react';
import { useVideo } from '../hooks/useVideo';
import HTML5Player from '../players/HTML5Player';
import VimeoPlayer from '../players/VimeoPlayer';
import YoutubePlayer from '../players/YoutubePlayer';

const VIMEO_PATTERN = /vimeo/;
const YOUTUBE_PATTERN = /youtube|youtu.be/;

const VideoContainer = ({ children }: any) => {
	const props = useVideo();
	const isVimeo = VIMEO_PATTERN.test(props.src);
	const isYoutube = YOUTUBE_PATTERN.test(props.src);

	let Player = HTML5Player;

	if (isVimeo) {
		Player = VimeoPlayer;
	}

	if (isYoutube) {
		Player = YoutubePlayer;
	}

	return (
		<>
			<Player {...props} />
		</>
	);
};

export default VideoContainer;
